const prismicContentTypes = {
  article: "article",
  webinar: "webinar",
  precedent: "precedent",
  download: "download",
  page: "page",
};

export default prismicContentTypes;
